import { haStatusType, HaStatusType } from '@elio/shared/models';

/**
 *
 * @param haInfo Return room HA  color class
 * @returns
 */
export const getHaStatusColor = (roomHaStatusType: HaStatusType | undefined): string => {
  let color: 'text-gray' | 'text-green' | 'text-orange' = 'text-gray';
  if (roomHaStatusType) {
    switch (roomHaStatusType) {
      case haStatusType.FUNCTIONAL: {
        color = 'text-green';
        break;
      }
      case haStatusType.NON_FUNCTIONAL: {
        color = 'text-orange';
        break;
      }
      default:
        color = 'text-gray';
    }
  }
  return color;
};
